import { useRef } from 'react';

import { ICON_SIZE, useSoundbarCanvas } from './RecordingIcon.hooks';
import { StyledCanvas, StyledRecordingIcon, StyledSvg } from './RecordingIcon.styled';

type RecordingIconProps = { analyser?: AnalyserNode | null };

export const RecordingIcon = (props: RecordingIconProps): JSX.Element => {
   const canvasRef = useRef<HTMLCanvasElement>(null);
   const analyser = props.analyser ?? null;
   useSoundbarCanvas(canvasRef, analyser);

   return (
      <StyledRecordingIcon>
         <StyledSvg
            width={ICON_SIZE}
            height={ICON_SIZE}
            viewBox={`0 0 ${ICON_SIZE} ${ICON_SIZE}`}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
         >
            <rect width={ICON_SIZE} height={ICON_SIZE} rx={ICON_SIZE / 2} fill='#C96262' />
            {analyser === null ? (
               <>
                  <rect x='9.40579' y='17' width='2' height='4' rx='1' fill='white' />
                  <rect x='13' y='17' width='2' height='4' rx='1' fill='white' />
                  <rect x='16.5942' y='17' width='2' height='4' rx='1' fill='white' />
                  <rect x='20.1884' y='17' width='2' height='4' rx='1' fill='white' />
                  <rect x='23.7826' y='17' width='2' height='4' rx='1' fill='white' />
                  <rect x='27.3768' y='17' width='2' height='4' rx='1' fill='white' />
               </>
            ) : null}
         </StyledSvg>
         {analyser === null ? null : <StyledCanvas ref={canvasRef} />}
      </StyledRecordingIcon>
   );
};
